import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase, ValidationError } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetPackageProductsRequest } from '../shared/get-package-products.request';
import { GetPackageProductsResponse } from '../shared/get-package-products.response';

@Injectable({
    providedIn: 'root'
})
export class GetPackageProductsUseCase extends UseCase<GetPackageProductsRequest, Observable<GetPackageProductsResponse>> {
    packageProductsUrl = '/store/getPackageProducts';

    storeBackendUrl = '';

    constructor(
        private _apiRequestService: ApiRequestService,
        @Inject('STORE_BACKEND_URL') private _storeBackendUrl: string,
        _logService: LogService,
        protected override _http: HttpClient
    ) {
        super(_logService, _http);
        this.storeBackendUrl = _storeBackendUrl;
    }

    protected override validate(request: GetPackageProductsRequest) {
        if (request.routerLink === null || '') {
            throw new ValidationError('The routerLink for Package is null');
        }
    }

    protected override executeBusinessLogic(
        request: void | GetPackageProductsRequest
    ): void | Observable<GetPackageProductsResponse> {
        return this._apiRequestService.sendRequest(this.storeBackendUrl, request, true, this.packageProductsUrl);
    }
}
